import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 21 20"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  stroke: "currentColor",
  "stroke-linejoin": "round",
  d: "M2.86279 15.7281C2.86279 14.7153 3.26512 13.744 3.98127 13.0278C4.69742 12.3117 5.66873 11.9093 6.68152 11.9093H14.319C15.3317 11.9093 16.3031 12.3117 17.0192 13.0278C17.7354 13.744 18.1377 14.7153 18.1377 15.7281C18.1377 16.2344 17.9365 16.7201 17.5784 17.0782C17.2204 17.4363 16.7347 17.6374 16.2283 17.6374H4.77215C4.26576 17.6374 3.78011 17.4363 3.42203 17.0782C3.06396 16.7201 2.86279 16.2344 2.86279 15.7281Z"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  stroke: "currentColor",
  d: "M10.4998 8.09063C12.0816 8.09063 13.3638 6.80836 13.3638 5.22659C13.3638 3.64482 12.0816 2.36255 10.4998 2.36255C8.91802 2.36255 7.63574 3.64482 7.63574 5.22659C7.63574 6.80836 8.91802 8.09063 10.4998 8.09063Z"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "user"}) } }